var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"menu",class:{ 'organism-menu-bar-universe': true, scrolled: _vm.isScrolled }},[_c('div',{staticClass:"logo-center",on:{"click":_vm.scrollTopMethod}},[_c('NuxtLink',{attrs:{"tag":"div","to":"/"}},[_c('AtomsCommonAtomLogo')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }